import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./Login";
import IzinTalep from "./izin_talep";
import IzinOnay from "./izin_onay";
import YonetimPanel from "./yonetim_panel";
import KullaniciPanel from "./kullanici_panel";
import YonetimIzinGiris from "./yonetim_izin_giris";
import TopluIzin from "./toplu_izin";
import React, { useEffect } from "react";
//import Navbar from "./NavBar";


function App() {

  //const location = useLocation();
  //const user = location.state?.user||JSON.parse(localStorage.getItem("user")); // Check if user is logged in

  return (
    
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/izin_talep" element={ <IzinTalep />} /> 
        <Route path="/izin_onay" element={<IzinOnay />} /> 
        <Route path="/yonetim_panel" element={<YonetimPanel />} /> 
        <Route path="/kullanici_panel" element={<KullaniciPanel />} />
        <Route path="/yonetim_izin_giris" element={<YonetimIzinGiris />} /> 
        <Route path="/toplu_izin" element={<TopluIzin />} /> 
      </Routes>
      
  );
}

export default App;
